import styled from 'styled-components';
import { Link as LinkRouter } from 'react-router-dom';
import { Link as LinkScroll } from 'react-scroll';

const FooterContainer = styled.footer`
  background-color: #101010;
`;

const FooterWrapper = styled.div`
  padding: 48px 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 1100px;
  margin: 0 auto;
`;

const FooterLinksContainer = styled.div`
  width: 100%;
  max-width: 1000px;
  display: flex;
  justify-content: center;

  @media (max-width: 820px) {
    padding-top: 32px;
    flex-wrap: wrap;
  }
`;
const FooterLinksWrapper = styled.div`
  display: flex;
  flex-direction: column;

  /* @media (max-width: 820px) {
    flex-direction: column;
  } */
`;

const FooterLinkItems = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  margin: 16px;
  text-align: left;
  width: 160px;
  color: var(--color-white);

  @media (max-width: 420px) {
    margin: 0;
    padding: 10px;
    width: 100%;
  }
`;

const FooterLink = styled(LinkRouter)`
  color: var(--color-white);
  text-decoration: none;
  margin-bottom: 0.5rem;
  font-size: 14px;
  transition: var(--transition);

  &:hover::before {
    content: '⟶';
    margin-right: 5px;
    transition: var(--transition);
  }

  &:hover {
    color: var(--color-primary);
    transition: var(--transition);
  }
`;

const FooterLinkTitle = styled.h1`
  color: var(--color-white);
  font-size: 18px;
  margin-bottom: 1rem;
  margin-left: 1rem;
`;

// #############################################################################

const SocialMedia = styled.section`
  max-width: 1000px;
  width: 100%;
`;

const SocialMediaWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 100%;
  margin: 40px auto 0 auto;

  @media screen and (max-width: 820px) {
    flex-direction: column;
  }
`;

const SocialLogo = styled(LinkScroll)`
  justify-self: start;
  cursor: pointer;
  text-decoration: none;
  font-size: 1.5rem;
  font-weight: bold;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  text-transform: uppercase;

  background: linear-gradient(to right, #01bf71, #9f2fff);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const WebsiteRights = styled.small`
  color: #fff;
  margin-bottom: 16px;
`;

const SocialIcons = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 180px;
`;

const SocialIconLink = styled.a`
  color: #fff;
  font-size: 24px;
`;

export {
  FooterContainer,
  FooterWrapper,
  FooterLinksContainer,
  FooterLinksWrapper,
  FooterLinkTitle,
  FooterLinkItems,
  FooterLink,
  SocialMedia,
  SocialMediaWrapper,
  SocialLogo,
  WebsiteRights,
  SocialIcons,
  SocialIconLink
};
